module.exports = __webpack_public_path__ + "img/bk_18_03.489e285f.png";